'use strict';

import Vue from 'vue';
import {initialiseElement} from '../modules/scroller';
import inventoryService from './services/inventory-service';

const SELECTOR = '.performances-scroller, .performance-dates';

(function() {
    document.querySelectorAll(SELECTOR).forEach(el => {
        const vm = new Vue({
            el,
            data: {
                loading: true,
                performances: [],
            },
            methods: {
                init : function () {
                    let perfNos = this.$el.getAttribute('data-perf-nos');
                    let prodSeasonNos = this.$el.getAttribute('data-prod-season-nos');
                    let balletID = parseInt(this.$el.getAttribute('data-ballet-id'), 10);
                    let seasonTitles;
                    try {
                        seasonTitles = JSON.parse(this.$el.dataset.seasonTitles);
                    } catch(e) {
                        seasonTitles = {};
                    }

                    let performancesPromise;

                    if (perfNos !== undefined || prodSeasonNos !== undefined) {
                        // Load performances
                        perfNos = (perfNos || '')
                            .split(',')
                            .filter(x => x)
                            .map(perfNo => parseInt(perfNo, 10));

                        prodSeasonNos = (prodSeasonNos || '')
                            .split(',')
                            .filter(x => x)
                            .map(prodSeasonNo => parseInt(prodSeasonNo, 10));
                        performancesPromise = inventoryService.getPerformances(prodSeasonNos, perfNos);
                    } else {
                        performancesPromise = inventoryService.getInventory();
                    }
                    performancesPromise.then(data => {
                        if (balletID) {
                            data = data.map(perf => {
                                perf.performed_with = perf.performed_with.reduce((carry, ballet) => {
                                    if (ballet.id !== balletID) {
                                        carry.push(ballet);
                                    }
                                    return carry;
                                }, []);
                                return perf;
                            });
                        }

                        this.performances = data.reduce((carry, perf) => {
                            let seasonTitle = seasonTitles[perf.season_no] ? seasonTitles[perf.season_no] : perf.season_page_title;
                            let seasonAdded = !!carry.find(testPerf => testPerf.season && testPerf.season.title === seasonTitle);

                            if (!seasonAdded) {
                                perf.season = {
                                    season_no: perf.season_no,
                                    season_page_id: perf.season_page_id,
                                    desc: perf.season_desc,
                                    title: seasonTitle,
                                };
                            } else {
                                perf.season = false;
                            }
                            carry.push(perf);
                            return carry;
                        }, []);
                    });
                },
            },
            watch: {
                performances: function () {
                    // Need to have the element appear before initialising the scroll
                    this.loading = false;
                    setTimeout(() => {
                        this.performances.length > 0 && initialiseElement(this.$el);
                    }, 100);
                }
            }
        });

        vm.init();
    });
}());
